export function getServiceNotes(notes: any, state: string): any[] {
  const suffix = state === 'Preventivo'
    ? 'itinerario_preventivo'
    : state === 'Confermata' ? 'itinerario_conferma' : '';

  if (!suffix || !Array.isArray(notes)) {
    return [];
  }

  return notes.filter((item: any) => item && item.id && item.id.endsWith(suffix));
}